/*
 * @Author: cryi.liu
 * @Date: 2020-05-06 10:37:12
 * @LastEditTime: 2020-05-14 18:03:54
 * @Description: 原 PSS 风格页面数据仓库
 */

export default {
  namespaced: true,

  state: {
    // 面包屑数据
    breadcrumb: [],

    // 正在处理
    processing: {
      show: true,
      text: '正在处理...',
    },
  },

  getters: {
    // 获取面包屑数据
    breadcrumb({ breadcrumb }) {
      return breadcrumb;
    },
    // 获取正在处理蒙版显示状态
    processingShowState({ processing: { show } }) {
      return show;
    },
    // 获取正在处理蒙版显示文字
    processingShowText({ processing: { text } }) {
      return text;
    },
  },

  mutations: {
    // 设置面包屑数据
    setBreadcrumb(state, { breadcrumb }) {
      state.breadcrumb = breadcrumb;
    },
    // 设置正在处理蒙版显示状态
    setProcessingShowState(state, { show }) {
      state.processing.show = show;
    },
    // 设置正在处理蒙版显示文字
    setProcessingShowText(state, { text }) {
      state.processing.text = text;
    },
  },

  actions: {
    invokeSetBreadcrumb({ commit }, payload) {
      commit('setBreadcrumb', payload);
    },
    invokeSetProcessingShowState({ commit }, payload) {
      commit('setProcessingShowState', payload);
    },
    invokeSetProcessingShowText({ commit }, payload) {
      commit('setProcessingShowText', payload);
    },
  },
};
